var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYale({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Art",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.8939,
    y1: -260.0107,
    x2: 30.0812,
    y2: -207.8442,
    gradientTransform: "matrix(1 0 0 -1 0 -200.46)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0477,
    style: {
      stopColor: "#FFB800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3278,
    style: {
      stopColor: "#FFD000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FFD900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6722,
    style: {
      stopColor: "#FFDD09"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9523,
    style: {
      stopColor: "#FFE921"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEB26"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60,30c0,16.6-13.4,30-30,30C13.4,60,0,46.6,0,30S13.4,0,30,0C46.6,0,60,13.4,60,30"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.8,19h-3.9l-4.8,9l-4.8-9H5.4l6.9,12.4v7.7h3.6v-7.7L22.8,19L22.8,19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,24.1c-4,0-5.9,2.1-6.1,5h3.5c0.1-1.3,0.8-2.1,2.6-2.1c2.1,0,2.7,1,2.7,2.5v0.9h-3.1c-2,0-3.3,0.2-4.3,0.9 c-1.2,0.8-1.9,1.9-1.9,3.6c0,2.1,1.3,4.5,5.3,4.5c2,0,3.3-0.6,4.2-1.7v1.5h3.3v-9.6C32.1,26.4,30.4,24.1,26,24.1z M28.6,34.5 c0,1.6-1.4,2.3-3.3,2.3c-2.1,0-2.6-0.9-2.6-2c0-0.6,0.2-1.1,0.7-1.4c0.4-0.2,1-0.3,2.2-0.3h3L28.6,34.5L28.6,34.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9,26.2c-1.1-1.3-2.8-2.2-5.2-2.2c-2.5,0-4.2,0.9-5.3,2.2c-1.3,1.6-1.6,3.9-1.6,5.6c0,1.6,0.3,3.5,1.4,5.1 c1.1,1.5,2.9,2.5,5.7,2.5c1.9,0,3.4-0.4,4.5-1.2c1.1-0.8,1.9-2.1,2-3.4h-3.5c-0.1,0.5-0.4,0.9-0.8,1.3c-0.5,0.4-1.2,0.5-2.2,0.5 c-1.4,0-2.3-0.4-2.8-1.2c-0.4-0.6-0.6-1.6-0.6-2.5h10.1C53.6,30.2,53.2,27.8,51.9,26.2z M43.4,30.3c0-0.8,0.3-1.9,0.9-2.5 c0.6-0.6,1.4-0.9,2.4-0.9c1,0,1.8,0.3,2.4,0.9c0.6,0.6,0.8,1.7,0.8,2.5L43.4,30.3L43.4,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5,39.3v-3.1c-1.6,0.1-2-0.6-2-1.9V19h-3.4v15.6C34.1,37.6,35.2,39.5,39.5,39.3L39.5,39.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYale);
export default __webpack_public_path__ + "static/media/yale.d4418f8683998351e6e89bdbc6f33646.svg";
export { ForwardRef as ReactComponent };